import React, { useState } from 'react';
import { ConditionPicker } from './ConditionPicker';
import { ReflectQuestion } from './ReflectQuestion';
import { ReflectResults } from './ReflectResults';
import { OpportunityDetail } from './OpportunityDetail';
import { getQuestionsForCondition, getCommunity, getAnswersForQuestion, getOpportunities } from './reflectData';

export const ReflectExperience = ({ conditions = [], firstName = '', state = '', onDone }) => {
  const [step, setStep] = useState(conditions.length > 1 ? 0 : 1);
  const [selectedCondition, setSelectedCondition] = useState(
    conditions.length === 1 ? conditions[0] : ''
  );
  const [questionIndex, setQuestionIndex] = useState(0);
  const [answeredCount, setAnsweredCount] = useState(0);
  const [answer, setAnswer] = useState('');
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);

  const handleConditionSelect = (condition) => {
    setSelectedCondition(condition);
    setQuestionIndex(0);
    setStep(1);
  };

  const questions = getQuestionsForCondition(selectedCondition);
  const currentQuestion = questions[questionIndex] || questions[0];
  const community = getCommunity(selectedCondition);
  const communityAnswers = getAnswersForQuestion(currentQuestion.id);
  const opportunities = getOpportunities(selectedCondition);
  const hasMoreQuestions = questionIndex < questions.length - 1;

  const handleSubmit = () => {
    setAnsweredCount(prev => prev + 1);
    setStep(2);
  };

  const handleNextQuestion = () => {
    setQuestionIndex(prev => prev + 1);
    setAnswer('');
    setStep(1);
  };

  if (selectedOpportunity) {
    return (
      <OpportunityDetail
        opportunity={selectedOpportunity}
        onBack={() => setSelectedOpportunity(null)}
      />
    );
  }

  if (step === 0) {
    return (
      <ConditionPicker conditions={conditions} firstName={firstName} onSelect={handleConditionSelect} />
    );
  }

  if (step === 1) {
    return (
      <ReflectQuestion
        condition={selectedCondition}
        question={currentQuestion.question}
        answer={answer}
        onAnswerChange={setAnswer}
        onSubmit={handleSubmit}
        onBack={() => conditions.length > 1 ? setStep(0) : onDone()}
      />
    );
  }

  return (
    <ReflectResults
      condition={selectedCondition}
      community={community}
      communityAnswers={communityAnswers}
      userAnswer={answer}
      userState={state}
      answeredCount={answeredCount}
      hasMoreQuestions={hasMoreQuestions}
      opportunities={opportunities}
      onNextQuestion={handleNextQuestion}
      onSelectOpportunity={setSelectedOpportunity}
      onDone={onDone}
    />
  );
};
